import React from 'react';
import styles from './Container.module.css';

export default function Container({ children, className = '', narrow = false, ...rest }) {
  const cls = `${styles.container} ${narrow ? styles.narrow : ''} ${className}`;
  return (
    <div className={cls.trim()} {...rest}>
      {children}
    </div>
  );
}
